// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__15SNG","footer":"ModalFilter_footer__2Aj8f"};